export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "PO-Revision-Date": "2025-01-16T18:28:34.729Z",
    "Language": "pl-PL",
    "Messages": {
        ".": "",
        "...": "",
        "2 dni": "",
        "2 miesiące": "",
        "2 tygodnie": "",
        "3 dni": "",
        "3 miesiące": "",
        "4 dni": "",
        "5 dni": "",
        "6 dni": "",
        "Aby skonfigurować wysyłkę, należy uzułenić wymagane pola.": "",
        "Adres": "",
        "Adres email": "",
        "Adres email jest pusty.": "",
        "Adres email odbiorcy": "",
        "Adres endpointu": "",
        "Adres URL": "",
        "Adres URL został skopiowany.": "",
        "Adres został skopiowany do schowka.": "",
        "AI": "",
        "Akcent": "",
        "Akceptacja": "",
        "Akceptacja dokumentów": "",
        "Akceptacja dokumentu": "",
        "Akceptacja własnych dokumentów": "",
        "Akceptacja wszystkich dokumentów": "",
        "Akceptowalny typ plików": "",
        "Akceptowany format danych": "",
        "Akceptuj": "",
        "Akcje": "",
        "Akordeon": "",
        "Aktualizacja definicji": "",
        "Aktualizacja dokumentu": "",
        "Aktualizacja encji": "",
        "Aktualizacja wpisu": "",
        "Aktualizowane pola": "",
        "Aktualizuj": "",
        "Aktywne": "",
        "Aktywność i widoczność w menu panelu.": "",
        "Aktywny": "",
        "Aktywny webhook": "",
        "AND — użytkownik musi mieć wszystkie zaznaczone uprawnienia. OR — wystarczy dowolne z nich. Zaznacz uprawnienia poniżej i wybierz sposób ich łączenia.": "",
        "Ankieta": "",
        "Anonimizacja": "",
        "Anonimowy": "",
        "Anulowany": "",
        "Anuluj": "",
        "Any sprawdza, czy istnieje pasujący rekord; Count zwraca ich liczbę; FirstOrDefault zwraca pierwszy rekord; ToList zwraca wszystkie rekordy; Sum, Min, Max i Average obliczają wartość dla wskazanego pola.": "",
        "Aplikacja": "",
        "Aranżacje: %0": "",
        "Audio": "",
        "Automatyzacja": "",
        "Autouzupełnianie": "",
        "Baza danych": "",
        "Bazowy model danych": "",
        "Bezpieczeństwo": "",
        "Biblioteka skryptów": "",
        "Bieżący dokument": "",
        "Błąd": "",
        "Błędne": "",
        "Błędny": "",
        "Bloczek przetwarza wejście collection. Ścieżka JSON wskazuje pole elementu, np. customer.email. Znak $ oznacza cały element kolekcji.": "",
        "Bool": "",
        "brak": "",
        "Brak": "",
        "Brak danych": "",
        "Brak definicji formularza.": "",
        "Brak dodanych kolumn": "",
        "Brak drugiej wersji do porównania": "",
        "Brak komponentu": "",
        "Brak odpowiedzi": "",
        "Brak opublikowanej definicji formularza": "",
        "Brak pasujących elementów.": "",
        "Brak pasujących kontrolek wśród wczytanych.": "",
        "Brak różnic między wybranymi wersjami": "",
        "Brak sekcji": "",
        "Brak właściwości do konfiguracji.": "",
        "Brak wyboru": "",
        "brak wyboru...": "",
        "Brak wykonanych operacji.": "",
        "Brak załączników.": "",
        "Build": "",
        "Cache": "",
        "Cache będzie przechowywany z wykorzystaniem serwera Redis.": "",
        "Cache po stronie serwera": "",
        "Cache-Control": "",
        "Cechy": "",
        "Checkbox": "",
        "Ciemny": "",
        "Cyfry": "",
        "Czas pomiędzy": "",
        "Czas rozpoczęcia": "",
        "Czas trwania": "",
        "Czas zakończenia": "",
        "Cztery kolumny": "",
        "Czy na pewno usunąć kontrolkę?": "",
        "Czy na pewno usunąć opcję?": "",
        "Czy na pewno usunąć pytanie?": "",
        "Czy na pewno usunąć stronę formularza?": "",
        "Czy na pewno usunąć ten warunek?": "",
        "Dalej": "",
        "Dane": "",
        "Dane formularza są przechowywane w obiekcie Entry.": "",
        "Dane modułu": "",
        "Dane odbiorcy": "",
        "Dane osobowe": "",
        "Dane podglądu": "",
        "Dane skopiowane do schowka.": "",
        "Dane tabelaryczne": "",
        "Dane techniczne": "",
        "Dane webhooka": "",
        "Dane wejściowe": "",
        "Dane z formularza zapisywane anonimowo": "",
        "Dane źródła": "",
        "Data": "",
        "Data dodania": "",
        "Data i czas": "",
        "Data kalendarza": "",
        "Data rozpoczęcia": "",
        "Data rozpoczęcia publikacji": "",
        "Data wywołania": "",
        "Data zakończenia": "",
        "Data zakończenia publikacji": "",
        "Data: %0 | Autor: %1 | Status: %2": "",
        "Data: %0 | Status: %1": "",
        "DateTime": "",
        "Dedykowane": "",
        "Definicja": "",
        "Definicja (JSON)": "",
        "Definicja formularza znajduje się w obiekcie Form.": "",
        "Definicja pól dokumentów tej sekcji.": "",
        "Definicja skopiowana do schowka.": "",
        "Definicje": "",
        "Definicje zostały zaktualizowane.": "",
        "DELETE: Usunięcie wpisu": "",
        "Design Studio": "",
        "Diagram": "",
        "Diagram jest nieprawidłowy, nie zawiera żadnego wyzwalacza.": "",
        "Diagram jest nieprawidłowy, zawiera więcej niż jeden wyzwalacz.": "",
        "Diagram jest nieprawidłowy. Akcja \"%0 (%1)\" jest elementem dwóch różnych pętli.": "",
        "Diagram jest nieprawidłowy. Akcja \"%0 (%1)\" nie posiada rodzica.": "",
        "Diagram jest nieprawidłowy. Akcja \"%0 (%1)\" nie została poprawnie skonfigurowana.": "",
        "Diagram jest nieprawidłowy. Jedna ze ścieżek zawiera niezgodną liczbę początków i zakończeń pętli.": "",
        "Diagram jest nieprawidłowy. Jedna ze ścieżek zawiera zagnieżdżone pętle.": "",
        "Diagram scenariusza": "",
        "dla wybranego modelu danych.": "",
        "dla wybranego modułu dynamicznego.": "",
        "Długość": "",
        "Długość czasu przechowywania": "",
        "Długość geograficzna": "",
        "do": "",
        "Do": "",
        "do %0": "",
        "Do akceptacji": "",
        "Dodaj": "",
        "Dodaj dni": "",
        "Dodaj dokument": "",
        "Dodaj element": "",
        "Dodaj endpoint": "",
        "Dodaj formularz": "",
        "Dodaj grupę": "",
        "Dodaj kategorię": "",
        "Dodaj kolumnę": "",
        "Dodaj komponent": "",
        "Dodaj moduł": "",
        "Dodaj nową wersję dokumentu": "",
        "Dodaj obraz": "",
        "Dodaj opcję": "",
        "Dodaj parametr": "",
        "Dodaj podsumowanie": "",
        "Dodaj pole": "",
        "Dodaj pozycję": "",
        "Dodaj punkt": "",
        "Dodaj pytanie": "",
        "Dodaj scenariusz": "",
        "Dodaj sekcję": "",
        "Dodaj sekcję, aby skonfigurować jej formularz i właściwości.": "",
        "Dodaj stronę": "",
        "Dodaj warunek": "",
        "Dodaj webhook": "",
        "Dodaj webhooka": "",
        "Dodaj wiersz": "",
        "Dodaj wpis": "",
        "Dodaj wydarzenie": "",
        "Dodaj wyrażenie": "",
        "Dodaj źródło": "",
        "Dodaj źródło danych": "",
        "Dodaj...": "",
        "Dodane": "",
        "Dodane przez": "",
        "Dodanie endpointu": "",
        "Dodanie komponentu": "",
        "Dodanie modułu": "",
        "Dodanie webhooka": "",
        "Dodanie źródła danych": "",
        "Dodano za dużo plików (maksymalnie %0).": "",
        "Dodatkowe pola do wyszukiwarki": "",
        "Dodatkowe pola kont użytkowników": "",
        "Dodawanie": "",
        "Dodawanie dokumentów": "",
        "Dodawanie i edycja własnych dokumentów": "",
        "Dodawanie wartości dwóch kolumn": "",
        "Dokument": "",
        "Dokument został usunięty.": "",
        "Dokument został zduplikowany.": "",
        "Dokumenty": "",
        "Dołączanie plików": "",
        "Domyślna wartość": "",
        "Domyślnie ukryte": "",
        "Domyślnie widoczne": "",
        "Domyślny": "",
        "Dopasuj widok": "",
        "Dopuść brak odpowiedzi": "",
        "Dopuszczalne typy": "",
        "Dostęp do modułu": "",
        "Dostępna jako widget": "",
        "Dostępne endpointy REST API": "",
        "Dostępne są właściwości obiektów, bez ich metod.": "",
        "Dostępne zmienne": "",
        "Dostępność modułu": "",
        "Dostosuj funkcjonalności i sposób wyświetlania danych w sekcji.": "",
        "Double": "",
        "Dowolny": "",
        "Dowolny wynik (Any)": "",
        "Dozwolone rozszerzenia": "",
        "Dozwolone rozszerzenia plików": "",
        "Dozwolone są operację dodawania (+), usuwania (-), mnożenia (*), dzielenia (/),\r\n                                potęgowania (^2), pierwiastkowania (sqrt()). Jeżeli chcemy wyliczyć dane na podstawie\r\n                                innej kolumny musimy znać jej nazwę (zwykle jest to Numeric z liczbą na końcu np.\r\n                                Numeric2, możemy to sprawdzić klikając na daną kolumnę i odczytując nazwę z nagłówka\r\n                                zakładki konfiguracyjnej pola) oraz typ kolumny musi być ustawiony na liczbowy.": "",
        "Dozwolone są tylko małe i duże litery": "",
        "Dozwolone są tylko małe litery i znak -": "",
        "Drugie imię": "",
        "Duplikuj": "",
        "Duplikuj dokument": "",
        "Duplikuj punkt": "",
        "Duplikuj wydarzenie": "",
        "Duże litery": "",
        "Duży": "",
        "Duży układ siatki": "",
        "Dwie kolumny": "",
        "Dyrektywa max-age=N wskazuje, że odpowiedź pozostaje świeża do N sekund po wygenerowaniu odpowiedzi.": "",
        "Dyrektywa no-store wskazuje, że jakikolwiek cache dowolnego rodzaju nie powinien przechowywać tej odpowiedzi.": "",
        "Dyrektywa PRIVATE wskazuje, że odpowiedź może być przechowywana wyłącznie w prywatnej pamięci podręcznej (np. lokalnej pamięci przeglądarki).": "",
        "Dyrektywa przechowywania": "",
        "Dyrektywa PUBLIC wskazuje, że odpowiedź może być przechowywana we współdzielonej pamięci podręcznej (np. proxy).": "",
        "Dyrektywa s-maxage jest ignorowana przez prywatne pamięci podręczne i zastępuje wartość określoną przez dyrektywę max-age dla współdzielonych pamięci podręcznych.": "",
        "Dyrektywa s-maxage wskazuje, jak długo odpowiedź pozostaje aktualna we współdzielonej pamięci podręcznej (np. proxy).": "",
        "Dyrektywy zakresu": "",
        "Dzielenie": "",
        "Dzielenie na paczki": "",
        "dzień": "",
        "Dzień": "",
        "Dzisiaj": "",
        "Edycja definicji": "",
        "Edycja dokumentów": "",
        "Edycja dokumentu": "",
        "Edycja endpointu": "",
        "Edycja komponentu": "",
        "Edycja modułu": "",
        "Edycja scenariusza": "",
        "Edycja w dialogu": "",
        "Edycja webhooka": "",
        "Edycja wszystkich dokumentów": "",
        "Edycja źródła danych": "",
        "Edytor": "",
        "Edytor lokalizowany": "",
        "Edytowany webhook został zmieniony.": "",
        "Edytuj": "",
        "Edytuj dokument": "",
        "Edytuj nazwę kontrolki": "",
        "Edytuj punkt": "",
        "Edytuj wiersz": "",
        "Edytuj wpis": "",
        "Edytuj wydarzenie": "",
        "Edytuj wyrażenie": "",
        "Eksport do Excela": "",
        "Eksport dokumentów": "",
        "Eksportuj": "",
        "Element nadrzędny": "",
        "Element został usunięty": "",
        "Email": "",
        "Endpoint został dodany.": "",
        "Endpoint został usunięty.": "",
        "Endpoint został zaktualizowany.": "",
        "Endpointy zostały usunięte.": "",
        "Etap": "",
        "Etykieta": "",
        "Etykiety": "",
        "False": "",
        "Filmy": "",
        "Filtrowanie": "",
        "Filtrowanie listy dokumentów": "",
        "Filtry": "",
        "Format danych": "",
        "Formuła jest nieprawidłowa": "",
        "Formularz": "",
        "Formularz bazuje na nieaktualnej wersji definicji.": "",
        "Formularz jest wymagany": "",
        "Formularz nie jest gotowy do zapisu.": "",
        "Formularz przypisany do tej sekcji nie ma dostępnej opublikowanej definicji. Sprawdź konfigurację sekcji i publikację formularza w Design Studio.": "",
        "Formularz został dodany.": "",
        "Formularz został skopiowany.": "",
        "Formularz został usunięty.": "",
        "Formularz został utworzony.": "",
        "Formularz został wygenerowany, ale nie można go zastosować": "",
        "Formularz został zaakceptowany.": "",
        "Formularz został zaktualizowany.": "",
        "Formularze": "",
        "Fragment adresu URL prowadzący do sekcji.": "",
        "Funkcjonalności": "",
        "Generowanie formularza zakończone.": "",
        "Generuj": "",
        "Generuj formularz": "",
        "GET: Lista wpisów (sortowanie i stronicowanie)": "",
        "GET: Pobranie danych": "",
        "GET: Pobranie wpisu": "",
        "GET: Schemat (definicja formularza)": "",
        "Godzina": "",
        "Godzina maksymalna musi mieć format HH:mm lub HH:mm:ss.": "",
        "Godzina maksymalna nie może być wcześniejsza niż minimalna.": "",
        "Godzina minimalna musi mieć format HH:mm lub HH:mm:ss.": "",
        "Godzina musi mieć format HH:mm lub HH:mm:ss.": "",
        "Godzina musi odpowiadać krokowi minut: %0.": "",
        "Grafika wektorowa": "",
        "Grupa %0": "",
        "Grupa uprawnień %0": "",
        "Grupa, w której szukamy formularzy.": "",
        "Grupowanie": "",
        "Harmonogram": "",
        "Hasło": "",
        "Hierarchia": "",
        "Hierarchiczny": "",
        "Historia": "",
        "i zwróć obiekt": "",
        "Id": "",
        "Id dokumentu": "",
        "Id encji": "",
        "ID operacji": "",
        "ID procesu": "",
        "Id wpisu": "",
        "Identyfikator używany w adresach.": "",
        "Ignoruj wersjonowanie": "",
        "Ikona": "",
        "Ikona jest wymagana": "",
        "Ikona modułu": "",
        "Ikona widgetu": "",
        "Ikona widoczna obok nazwy komponentu w przyborniku.": "",
        "Ilość elementów: %0": "",
        "Ilość powtórzeń pętli": "",
        "Ilość powtórzeń po wystąpieniu błędu": "",
        "Ilość wierszy": "",
        "Ilość wyników do odrzucenia": "",
        "Ilość wyników do pobrania": "",
        "Ilość znaków": "",
        "Ilość znaków odpowiedzi": "",
        "Imię": "",
        "Import": "",
        "Import CSV": "",
        "Import dokumentów został rozpoczęty.": "",
        "Import modułu": "",
        "Importuj": "",
        "Importuj definicję formularza": "",
        "Importuj definicję scenariusza": "",
        "Indeksowanie": "",
        "Info": "",
        "Informacja": "",
        "Informacje o generatorze": "",
        "input1 < input2": "",
        "Instrukcje": "",
        "Int": "",
        "Jak napisać walidację": "",
        "Jak zbudować zapytanie": "",
        "Jakość obrazu": "",
        "Jasny": "",
        "Jedna kolumna": "",
        "Jedno uprawnienie do dostępu obejmuje wszystkie operacje w sekcji.": "",
        "Jeśli użyłeś zmiennych, test się nie powiedzie. Wykonaj test bez użycia zmiennych. Wyniki testu zawszę będą ograniczone do maksymalnie 10 pozycji.": "",
        "Język jest wymagany.": "",
        "JSON": "",
        "Kafelki": "",
        "Kalendarz": "",
        "Kanał jest wymagany": "",
        "Kategoria": "",
        "Kategoria formularzy modułu.": "",
        "Kategoria jest wymagana": "",
        "Kategoria została dodana.": "",
        "Kategoria została usunięta.": "",
        "Kategoria została zaktualizowana.": "",
        "Kategorie": "",
        "Każdy skrypt ma inną listę parametrów wejściowych.": "",
        "Kierunek sortowania": "",
        "Klucz": "",
        "Kod i walidacja": "",
        "Kod pocztowy": "",
        "Kod walidacji": "",
        "Kod źródłowy": "",
        "Kolejność i konfiguracja sekcji modułu.": "",
        "Kolejność sekcji": "",
        "Kolor": "",
        "Kolor ikony": "",
        "Kolumna": "",
        "Kolumny": "",
        "Komponent formularza": "",
        "Komponent którego wartość zostanie użyta jako nazwa elementu nadrzędnego. Dostępne tylko komponenty typu ``Tekst``.": "",
        "Komponent relacyjny": "",
        "Komponent został dodany.": "",
        "Komponent został usunięty.": "",
        "Komponent został zaktualizowany.": "",
        "Komponent źródłowy": "",
        "Komponenty": "",
        "Komunikat błędu": "",
        "Komunikat walidacji": "",
        "Konfiguracja": "",
        "Konfiguracja etapu": "",
        "Konfiguracja kolumn tabeli": "",
        "Konfiguracja listy": "",
        "Konfiguracja modelu": "",
        "Konfiguracja połączenia": "",
        "Konfiguracja zaawansowana": "",
        "Konfiguracja zapytania": "",
        "Koniec pętli": "",
        "Konstruktor": "",
        "Konta użytkowników": "",
        "Kontrolka": "",
        "Kontrolka dostępna publicznie": "",
        "Kontrolka jest obsługiwana na publicu.": "",
        "Kontrolka wyboru (pojedynczy wybór, value jest skrótem pobierającym pierwszy element z tablicy data)": "",
        "Kontrolka wyboru (wybór wielokrotny)": "",
        "Kontrolka wysyła zapytanie HTTP do zewnętrznego serwera i zwraca status oraz treść odpowiedzi.": "",
        "Konwertuj obrazy do formatu WebP": "",
        "Kopiuj": "",
        "Kopiuj adres": "",
        "Kopiuj dane": "",
        "Kopiuj definicję": "",
        "Kopiuj endpoint": "",
        "Kopiuj klucz": "",
        "Kopiuj URL": "",
        "Kraj": "",
        "Kreator modułu": "",
        "Krok minut": "",
        "Krok minut musi być liczbą z zakresu od 1 do 60.": "",
        "Kroki": "",
        "Kroki kreatora": "",
        "Krótka informacja o przeznaczeniu źródła.": "",
        "Krótki opis": "",
        "Łączenie treści": "",
        "Liczba": "",
        "Liczba całkowita": "",
        "Liczba dziesiętna": "",
        "Liczba rekordów (Count)": "",
        "Liczba wyników": "",
        "Liczba zmiennoprzecinkowa": "",
        "Linia": "",
        "Lista": "",
        "Lista elementów zostanie zawężona tylko do tych, które są pozwiązane z wybranymi wartościami z zaznaczonych komponentów.": "",
        "Lista ID": "",
        "Lista rekordów (ToList)": "",
        "Lista rozszerzeń oddzielona przecinkami.": "",
        "Lista rozwijalna": "",
        "Lista sortowalna": "",
        "Litery": "",
        "Litery i cyfry": "",
        "Logi": "",
        "Lokalizacja": "",
        "Lokalizowane": "",
        "Long": "",
        "lub obiekt JSON.": "",
        "Maksimum": "",
        "Maksymalna ilość plików": "",
        "Maksymalna rozdzielczość po optymalizacji: %0 × %1 px.": "",
        "Maksymalny rozmiar pliku w MB": "",
        "Maksymalny rozmiar pojedynczego pliku": "",
        "Małe litery": "",
        "Małe znaki": "",
        "Malejąco": "",
        "Mały": "",
        "Mały układ siatki": "",
        "Mapa": "",
        "Mapowanie": "",
        "Mapowanie danych": "",
        "Mapowanie wartości": "",
        "Mapowanie, filtrowanie, sortowanie i usuwanie duplikatów zwracają listę. Grupowanie zwraca obiekt grup, sumowanie liczbę, a dzielenie na paczki listę list.": "",
        "Mediana": "",
        "Metadane dokumentu": "",
        "Metoda": "",
        "Metoda HTTP": "",
        "Metoda HTTP wymagana przy wywołaniu webhooka.": "",
        "Metoda żądania HTTP": "",
        "Miejsca po przecinku": "",
        "Miejsca publikacji": "",
        "Miejscowość": "",
        "miesiąc": "",
        "Miesiąc": "",
        "Minimalna ilość plików": "",
        "Minimalna szerokość": "",
        "Minimapa": "",
        "Minimum": "",
        "Mniejsze lub równe": "",
        "Mniejsze niż": "",
        "Mnożenie": "",
        "Model danych": "",
        "Model danych i cechy można skonfigurować tylko podczas dodawania nowego formularza.": "",
        "Model danych wynika z definicji wybranego formularza. Aby użyć innego modelu, wybierz odpowiedni formularz.": "",
        "Model określa tabelę, z której zostaną pobrane dane.": "",
        "Model określony przez wybrany formularz.": "",
        "Moduł": "",
        "Moduł dynamiczny": "",
        "Moduł i sekcja": "",
        "Moduł niedostępny": "",
        "Moduł został dodany.": "",
        "Moduł został usunięty.": "",
        "Moduł został wyeksportowany.": "",
        "Moduł został zaktualizowany.": "",
        "module.": "",
        "Moduły": "",
        "Moduły dynamiczne": "",
        "Modyfikacja dokumentów": "",
        "Modyfikacja dokumentu w module": "",
        "Modyfikacja rekordu w bazie danych": "",
        "Moje dokumenty": "",
        "Moje punkty": "",
        "Moje wydarzenia": "",
        "Możliwość wielokrotnego wyboru": "",
        "Multimedia": "",
        "Na wejściu należy podać dane wejściowe, a następnie zadeklarować": "",
        "Na wyjściu zwracana jest encja wybranego modelu danych.": "",
        "Na wyjściu zwracany jest model wpisu wybranego formularza dynamicznego.": "",
        "Nadawanie uprawnień do dokumentów": "",
        "Nadawanie uprawnień do własnych dokumentów": "",
        "Nadawanie uprawnień do wszystkich dokumentów": "",
        "Nagłówek": "",
        "Nagłówki": "",
        "Nagłówki cache": "",
        "Najmniejsza wartość (Min)": "",
        "Najpierw wczytaj plik CSV.": "",
        "Największa wartość (Max)": "",
        "Należy wybrać model danych.": "",
        "Należy wybrać przynajmniej jedną akcję.": "",
        "Należy wybrać przynajmniej jedną właściwość modelu.": "",
        "Należy zapisać zmiany w scenariuszu przed uruchomieniem procesu.": "",
        "Narzędzia scenariusza": "",
        "Następny": "",
        "Nazwa": "",
        "Nazwa akcji": "",
        "Nazwa etapu": "",
        "Nazwa formularza": "",
        "Nazwa i ikona pomagają odnaleźć komponent w przyborniku formularza.": "",
        "Nazwa jest wymagana": "",
        "Nazwa kategorii": "",
        "Nazwa kolumny": "",
        "Nazwa kolumny z obrazem": "",
        "Nazwa kolumny z opisem": "",
        "Nazwa kolumny z wartością": "",
        "Nazwa komponentu": "",
        "Nazwa kontrolki": "",
        "Nazwa modelu": "",
        "Nazwa modułu": "",
        "Nazwa modułu w panelu.": "",
        "Nazwa musi mieć co najmniej 3 znaki": "",
        "Nazwa musi mieć co najmniej 4 znaki": "",
        "Nazwa nie może być dłuższa niż 30 znaków": "",
        "Nazwa nie może być dłuższy niż 50 znaków": "",
        "Nazwa pola": "",
        "Nazwa pola jest wymagana": "",
        "Nazwa przycisku ``Dalej``": "",
        "Nazwa przycisku ``Wstecz``": "",
        "Nazwa przycisku ``Wyślij``": "",
        "Nazwa scenariusza": "",
        "Nazwa sekcji w menu": "",
        "Nazwa sekcji w wybranym języku.": "",
        "Nazwa sekcji widoczna w menu modułu.": "",
        "Nazwa sekcji: A–Z": "",
        "Nazwa sekcji: Z–A": "",
        "Nazwa techniczna": "",
        "Nazwa ułatwiająca rozpoznanie webhooka na liście w panelu.": "",
        "Nazwa uprawnienia": "",
        "Nazwa warunku jest wymagana": "",
        "Nazwa warunku musi być unikalna": "",
        "Nazwa warunku musi się zaczynać od małej litery i może zawierać tylko znaki alfanumeryczne": "",
        "nazwa warunku...": "",
        "Nazwa webhooka": "",
        "Nazwa widoczna na liście źródeł danych.": "",
        "Nazwa wyświetlana": "",
        "Nazwa wyświetlana w przyborniku formularza.": "",
        "Nazwa wyświetlana: A–Z": "",
        "Nazwa wyświetlana: Z–A": "",
        "Nazwa zdarzenia": "",
        "Nazwa zmiennej jest wymagana": "",
        "Nazwa zmiennej musi być unikalna": "",
        "nazwa zmiennej...": "",
        "Nazwa źródła": "",
        "Nazwa źródła danych": "",
        "Nazwa, identyfikator i kategoria modułu.": "",
        "Nazwę zmiennej umieść między dwoma znakami": "",
        "Nazwisko": "",
        "Nazwy wartości": "",
        "Nazwy właściwości modelu": "",
        "Nazwy właściwości niezmiennych": "",
        "Nie": "",
        "Nie dotyczy plików SVG.": "",
        "Nie masz uprawnień do edycji tego modułu.": "",
        "Nie masz uprawnień do tego dokumentu": "",
        "Nie można tworzyć zapętlonych powiązań.": "",
        "Nie można zapisać zmian ponieważ skrypt się nie kompiluje.": "",
        "Nie podano wymaganej ilości znaków: %0.": "",
        "Nie podano wymaganej ilości znaków: %0. (%1)": "",
        "Nie udało się odczytać pliku CSV.": "",
        "Nie udało się pobrać danych do porównania.": "",
        "Nie udało się pobrać definicji formularzy.": "",
        "Nie udało się pobrać endpointów.": "",
        "Nie udało się pobrać kategorii.": "",
        "Nie udało się pobrać komponentów.": "",
        "Nie udało się pobrać listy modułów Studio.": "",
        "Nie udało się pobrać modułów.": "",
        "Nie udało się pobrać opublikowanej definicji formularza.": "",
        "Nie udało się pobrać scenariuszy.": "",
        "Nie udało się pobrać ustawień kont użytkowników": "",
        "Nie udało się pobrać ustawień pól dodatkowych.": "",
        "Nie udało się pobrać webhooka.": "",
        "Nie udało się pobrać webhooków.": "",
        "Nie udało się pobrać wersji formularza.": "",
        "Nie udało się pobrać źródeł danych.": "",
        "Nie udało się pobrać źródła danych.": "",
        "Nie udało się przygotować podglądu szablonu. Spróbuj ponownie.": "",
        "Nie udało się skopiować adresu URL.": "",
        "Nie udało się skopiować adresu.": "",
        "Nie udało się skopiować danych.": "",
        "Nie udało się skopiować definicji.": "",
        "Nie udało się skopiować klucza.": "",
        "Nie udało się skopiować wyniku.": "",
        "Nie udało się uruchomić procesu.": "",
        "Nie udało się usunąć {count} kategorii. Pozostały zaznaczone.": "",
        "Nie udało się usunąć scenariuszy: {count}.": "",
        "Nie udało się wczytać definicji formularza.": "",
        "Nie udało się wczytać definicji formularza. Spróbuj ponownie.": "",
        "Nie udało się wczytać formularza.": "",
        "Nie udało się wczytać historii scenariusza.": "",
        "Nie udało się wczytać komponentów.": "",
        "Nie udało się wczytać kontrolki złożonej.": "",
        "Nie udało się wczytać kontrolki złożonej. Jej zapisane źródło nie jest dostępne.": "",
        "Nie udało się wczytać listy modułów.": "",
        "Nie udało się wczytać modułu": "",
        "Nie udało się wczytać modułu.": "",
        "Nie udało się wczytać modułu. Spróbuj ponownie.": "",
        "Nie udało się wczytać operacji.": "",
        "Nie udało się wczytać powtórzeń operacji.": "",
        "Nie udało się wczytać szablonu.": "",
        "Nie udało się wczytać szczegółów procesu.": "",
        "Nie udało się wygenerować formularza": "",
        "Nie udało się zaimportować pliku CSV.": "",
        "Nie usunięto formularzy": "",
        "Nie wybrano pliku": "",
        "Nie wybrano użytkownika.": "",
        "Nie zaleca się włączać tej opcji dla formularza z istniejącymi dokumentami.": "",
        "Nie znaleziono formularza.": "",
        "Nieaktywny": "",
        "Nienazwane uprawnienie": "",
        "Niepoprawne wyrażenie regularne": "",
        "Nieprawidłowa definicja": "",
        "Niestandardowe logo i stopka": "",
        "Niestandardowy błąd": "",
        "Niewidoczne": "",
        "Nieznany": "",
        "Nieznany typ": "",
        "Nigdy": "",
        "Niska": "",
        "no-store (wyłącza cache)": "",
        "Nowa data": "",
        "Nowa sekcja": "",
        "Nowy moduł": "",
        "Nowy moduł dynamiczny": "",
        "np. Formularz kontaktowy": "",
        "np. Powiadomienie o zamówieniu": "",
        "Numer domu": "",
        "Numer mieszkania": "",
        "Obiekt JSON": "",
        "Obok siebie": "",
        "Obraz": "",
        "Obraz wyniku na podstawie ID z SQL.": "",
        "Obsługiwane kanały": "",
        "Obsługiwane powiadomienia": "",
        "Obsługiwane są wszystkie powiadomienia.": "",
        "od": "",
        "Od": "",
        "od %0": "",
        "Odblokuj edycję diagramu": "",
        "Oddzielne uprawnienia do dostępu, edycji, usuwania, akceptacji i nadawania uprawnień do dokumentów.": "",
        "Odejmowanie": "",
        "odpowiada parametr": "",
        "Odpowiedź dowolna": "",
        "Odpowiedzi": "",
        "Odpowiedzi: %0 na %1": "",
        "Odstęp": "",
        "Odśwież": "",
        "Omnitool": "",
        "Opcja %0": "",
        "Opcje": "",
        "Opcjonalnie wskaż pole i kierunek sortowania. Ma to znaczenie zwłaszcza przy wyborze pierwszego rekordu.": "",
        "Opcjonalnie wybierz pola, które mają znaleźć się w wyniku. Bez mapowania zwracany jest pełny rekord.": "",
        "Opcjonalny warunek Dynamic LINQ. Podaj wyrażenie bez nazwy parametru lambda.": "",
        "Operacja": "",
        "Operacja określa format wyniku: pojedynczą wartość, pierwszy rekord albo listę rekordów.": "",
        "Operacje": "",
        "Operacje w pętli": "",
        "Operacje wykonane": "",
        "Operator": "",
        "Opis": "",
        "Opis błędu": "",
        "Opis źródła": "",
        "Opisz formularz": "",
        "Opisz, jakie pola powinny znajdować się w formularzu.": "",
        "Optymalizacja obrazów": "",
        "Optymalizuj rozdzielczość obrazów": "",
        "Ostatnia aktywność: {0}": "",
        "Ostatnio używane": "",
        "Ostrzeżenie": "",
        "Otwórz edytor wyrażenia.": "",
        "Otwórz formularz": "",
        "Oznaczenie modułu w nawigacji.": "",
        "Pamięć podręczna": "",
        "Panel projektu": "",
        "Parametry query": "",
        "Parametry wejściowe pochodzą z innych podpiętych widgetów.": "",
        "Parametry wejściowe skryptu": "",
        "Parametry wymagane do wykonania zapytania": "",
        "Parser Liquid": "",
        "Pasek": "",
        "Pasek postępu": "",
        "Pełna kontrola nad właściwościami sekcji, uprawnieniami oraz endpointami API.": "",
        "Pełna treść wiadomości": "",
        "Pełny": "",
        "Pełny dokument": "",
        "Pierwiastkowanie wartości kolumny": "",
        "Pierwsza sekcja pozostaje widoczna.": "",
        "Pierwszy rekord (FirstOrDefault)": "",
        "Pierwszy wiersz jest nagłówkiem": "",
        "Pigułki": "",
        "Placeholder": "",
        "Plik": "",
        "Plik CSV nie zawiera danych.": "",
        "Pliki": "",
        "Pliki: %0": "",
        "po elementach kolekcji": "",
        "Pobieranie dokumentów": "",
        "Pobieranie dokumentu": "",
        "Pobieranie encji": "",
        "Pobieranie i aktualizacja encji": "",
        "Pobieranie i usuwanie encji": "",
        "Pobieranie listy encji": "",
        "Pobierz załącznik: {name}": "",
        "Początek pętli": "",
        "Początkowa ilość wierszy": "",
        "Podaj ID dokumentu lub nazwę parametru wejściowego.": "",
        "Podaj nazwę formularza": "",
        "Podaj nazwę scenariusza": "",
        "Podaj nową nazwę": "",
        "Podajemy go w formie jednoliniowej. Przykład:": "",
        "Podana nazwa jest zajęta.": "",
        "Podana wartość jest nieprawidłowa.": "",
        "Podane ręcznie": "",
        "Podanie nazwy jest wymagane.": "",
        "Podano adres": "",
        "Podano nieprawidłowe dane": "",
        "Podano nieprawidłowe dane.": "",
        "Podano nieprawidłowe dane. (%0)": "",
        "Podgląd": "",
        "Podgląd formularza": "",
        "Podgląd kalendarza": "",
        "Podgląd listy": "",
        "Podgląd mapy": "",
        "Podgląd modułu": "",
        "Podgląd tabeli": "",
        "Podgląd wyniku jest niedostępny. Aby zobaczyć podgląd, scenariusz musi się wykonać poprawnie przynajmniej jeden raz.": "",
        "Podgląd wyniku wybranego etapu": "",
        "Podpis": "",
        "Podpis modułu w wybranym języku.": "",
        "Podproces": "",
        "Podstawowe": "",
        "Podstawowe operacje na datach": "",
        "Podstawowe operacje na liczbach": "",
        "Podstawowe operacje tekstowe": "",
        "Podstawowe operacje warunkowe": "",
        "Podsumowanie procesu": "",
        "Pojedynczy": "",
        "Pojedynczy formularz": "",
        "Pokaż": "",
        "Pokaż etykietę": "",
        "Pokaż filtr w domyślnym widoku.": "",
        "Pokaż kolumnę w domyślnym widoku.": "",
        "Pokaż numery stron": "",
        "Pokaż numery tygodnia na kalendarzu": "",
        "Pokaż przycisk ``Wyślij``": "",
        "Pokaż starsze wersje": "",
        "Pokaż tytuł formularza": "",
        "Pokaż tytuł sekcji": "",
        "Pokaż tytuł strony": "",
        "Pokaż tytuły stron": "",
        "Pokaż więcej": "",
        "Pokaż więcej komponentów": "",
        "pół roku": "",
        "Pola": "",
        "Pola obsługiwane przez generator dynamicznych formularzy.": "",
        "Pola w formularzu": "",
        "Pola z wybranego formularza pojawią się w edytorze konta.": "",
        "Pole": "",
        "Pole \"%0\" jest wymagane.": "",
        "Pole \"%0\" jest wymagane. (%1)": "",
        "Pole \"%0\" nie zawiera prawidłowego adresu email.": "",
        "Pole \"%0\" nie zawiera prawidłowego adresu URL.": "",
        "Pole \"%0\" wymaga uzupełnienia wszystkich elementów": "",
        "Pole \"%0\" zawiera niedozwoloną wartość.": "",
        "Pole \"%0\" zawiera nieprawidłowy symbol.": "",
        "Pole \"Akcje\" jest wymagane.": "",
        "Pole \"Drugie imię\" jest wymagane.": "",
        "Pole \"Id dokumentu\" jest wymagane.": "",
        "Pole \"Id encji\" jest wymagane.": "",
        "Pole \"Imię\" jest wymagane.": "",
        "Pole \"Liczba wyników\" jest wymagane.": "",
        "Pole \"Model\" jest wymagane.": "",
        "Pole \"Moduł dynamiczny\" jest wymagane.": "",
        "Pole \"Moduł\" jest wymagane.": "",
        "Pole \"Nazwa modelu\" jest wymagane.": "",
        "Pole \"Nazwa zdarzenia\" jest wymagane.": "",
        "Pole \"Nazwisko\" jest wymagane.": "",
        "Pole \"Operacja\" jest wymagane.": "",
        "Pole \"Podproces\" jest wymagane.": "",
        "Pole \"Pole agregacji\" jest wymagane dla tej operacji.": "",
        "Pole \"Pole\" jest wymagane.": "",
        "Pole \"Sekcja modułu\" jest wymagane.": "",
        "Pole \"Sekcja\" jest wymagane.": "",
        "Pole \"Skrypt wykonywalny\" jest wymagane.": "",
        "Pole \"Typ agregacji\" jest wymagane.": "",
        "Pole \"Tytuł\" jest wymagane.": "",
        "Pole \"Wyrażenie EQL\" jest wymagane.": "",
        "Pole agregacji": "",
        "Pole jest wymagane": "",
        "Pole może zawierać jedynie cyfry.": "",
        "Pole może zawierać jedynie cyfry. (%0)": "",
        "Pole może zawierać jedynie litery i cyfry.": "",
        "Pole może zawierać jedynie litery i cyfry. (%0)": "",
        "Pole może zawierać jedynie litery.": "",
        "Pole może zawierać jedynie litery. (%0)": "",
        "Pole typu \"%0\" jest niedozwolone w tym formularzu.": "",
        "Pole wymaga podania przynajmniej jednego znaku specjalnego.": "",
        "Pole wymaga podania przynajmniej jednej cyfry.": "",
        "Pole wymaga podania przynajmniej jednej dużej litery.": "",
        "Pole wymaga podania przynajmniej jednej małej litery.": "",
        "Pole wymagane": "",
        "Pole zawiera": "",
        "Pomniejsz": "",
        "Pomoc": "",
        "Pomoc dotycząca walidacji": "",
        "Ponów": "",
        "Poprawne": "",
        "Poprawny": "",
        "Poprzedni": "",
        "Porównaj wersje": "",
        "Porównania": "",
        "Porównanie": "",
        "Porównanie wersji": "",
        "Porównywana wersja": "",
        "POST: Dowolne wyszukiwanie (Zapytanie EQL)": "",
        "POST: Upload załączników": "",
        "POST: Utworzenie wpisu": "",
        "POST: Zapisanie zmian": "",
        "Postęp formularza": "",
        "Potwierdź akceptację": "",
        "Potwierdź usunięcie": "",
        "Potwierdź usunięcie.": "",
        "Potwierdzenie usunięcia": "",
        "Powiadomienia": "",
        "Powiadomienie jest wymagane": "",
        "Powiadomienie systemowe": "",
        "Powiązana kontrolka": "",
        "Powiększ": "",
        "Powiększenie diagramu": "",
        "Powinno się dodać dyrektywę PRIVATE dla treści personalizowanych dla użytkownika, zwłaszcza dla odpowiedzi otrzymywanych po zalogowaniu i z uwzględnieniem uprawnień.": "",
        "Powrót": "",
        "Powtórzenia": "",
        "Poziom dostępu do webhooka": "",
        "Poziom dostępu użytkownika": "",
        "Poziom uprawnień": "",
        "Pozostałe zaznaczenie zachowano.": "",
        "pozwala na wykorzystanie zaawansowanego edytora tekstu.": "",
        "Pozwól na dodawanie wierszy": "",
        "Pozwól na sortowanie wierszy": "",
        "Pozycja na liście": "",
        "Pozycje zostały zapisane.": "",
        "Prezentacja": "",
        "private (tylko cache przeglądarki)": "",
        "Procent": "",
        "Proces": "",
        "Proces został uruchomiony.": "",
        "Projekt": "",
        "Prompt": "",
        "Prompt jest wymagany.": "",
        "Proste": "",
        "Proste uprawnienia": "",
        "Prosty": "",
        "Przebieg procesu na diagramie": "",
        "Przedrostek": "",
        "Przejdź do kolejnego kroku gdy:": "",
        "Przekroczono dozwoloną ilość znaków: %0.": "",
        "Przekroczono dozwoloną ilość znaków: %0. (%1)": "",
        "Przełącznik": "",
        "Przenieś filtr": "",
        "Przenieś kolumnę": "",
        "Przenieś niżej": "",
        "Przenieś sekcję": "",
        "Przenieś wiersz": "",
        "Przenieś wyżej": "",
        "Przeniesienie wpisu do kosza": "",
        "Przeniesione": "",
        "Przeniesiono": "",
        "Przerwany": "",
        "Przesuń do góry": "",
        "Przesuń na dół": "",
        "Przybliżenie": "",
        "Przybornik": "",
        "Przygotuj skrypt C#, korzystając z parametrów wejściowych pochodzących z podpiętych etapów. Aby sprawdzić poprawność kompilacji, użyj przycisku Build w zakładce Skrypt (C#). Wynik pojawi się w konsoli pod edytorem.": "",
        "Przykład dla rekordów o identyfikatorze zamówienia 1:": "",
        "Przykład kodu walidacji": "",
        "Przykład mapowania z wybranymi polami:": "",
        "Przykład pola z ceną brutto:": "",
        "Przykład walidacji": "",
        "Przykładowa struktura danych": "",
        "Przykłady": "",
        "Przykłady konfiguracji": "",
        "Przypisz tablicę komunikatów do": "",
        "przypisz wynik etapu...": "",
        "Przyrostek": "",
        "Przywrócenie wpisu z kosza": "",
        "public (cache przeglądarki i proxy)": "",
        "Punkt został zduplikowany.": "",
        "Puste pole używa ikony modułu.": "",
        "PUT: Aktualizacja wpisu": "",
        "Pytania": "",
        "Query string": "",
        "Radio": "",
        "Reaguj na zmiany wybranych właściwości": "",
        "Ręczne uruchomienie": "",
        "Reguła walidacji": "",
        "Relacyjne": "",
        "Renderer MJML": "",
        "Request body": "",
        "REST API": "",
        "RESTful API": "",
        "Rezultat": "",
        "Rodzaj odpowiedzi": "",
        "Rodzaj pętli": "",
        "Rodzaj zwracanego wyniku": "",
        "rok": "",
        "Rok": "",
        "Rosnąco": "",
        "Równe": "",
        "Równość": "",
        "Rozmiar obrazu": "",
        "Rozmiar okna dialog": "",
        "Rozmiar paczki": "",
        "Rozmiar paczki musi być większy od zera.": "",
        "Rozmiar podawany w bajtach.": "",
        "Rozmieść równomiernie": "",
        "Różne": "",
        "Rozwijane": "",
        "Satysfakcja": "",
        "Scenariusz aktywny": "",
        "Scenariusz jest aktywowany po wywołaniu wybranego Webhooka.": "",
        "Scenariusz jest aktywowany po wywołaniu wybranego zdarzenia.": "",
        "Scenariusz jest aktywowany według wybranego hamonogramu.": "",
        "Scenariusz został dodany.": "",
        "Scenariusz został utworzony.": "",
        "Scenariusz został zaktualizowany.": "",
        "Ścieżka JSON": "",
        "Ścieżka JSON jest wymagana.": "",
        "Sekcja": "",
        "Sekcja lokalizowana": "",
        "Sekcja modułu": "",
        "Sekcja powtarzalna": "",
        "Sekcja ukryta": "",
        "Sekcja zostanie skonfigurowana z domyślnymi właściwościami, uprawnieniami i endpointami API.": "",
        "Sekcje modułu": "",
        "Sekcje specyfikacji EQL": "",
        "Sekcje: %0": "",
        "Selektor ikony": "",
        "Selektor kolorów": "",
        "Server Side Cache": "",
        "Skala 1-5": "",
        "Skopiowano": "",
        "Skopiowano klucz": "",
        "Skrypt (C#)": "",
        "Skrypt C#": "",
        "Skrypt wykonywalny": "",
        "Słownik": "",
        "Sortowanie": "",
        "Sortuj": "",
        "Sparametryzowane": "",
        "Specjalizowane": "",
        "Specyfikacja": "",
        "Sposób dystrybucji": "",
        "Sposób prezentacji dokumentów w panelu.": "",
        "Sposób prezentacji zakładek": "",
        "Sposób przekazania Id encji": "",
        "Sposób wyszukiwania": "",
        "Sprawdza rzeczywisty typ pliku.": "",
        "Sprawdzenie czy pusty": "",
        "Spróbuj ponownie": "",
        "Średni": "",
        "Średnia": "",
        "Średnia wartość (Average)": "",
        "Stała wartość": "",
        "Stan": "",
        "Standardowe": "",
        "Standardowe uprawnienia": "",
        "Standardowy": "",
        "Start": "",
        "Status": "",
        "Status dokumentu został zmieniony.": "",
        "Status modułu": "",
        "Status publikacji": "",
        "Status webhooka": "",
        "Status żądania": "",
        "string": "",
        "String": "",
        "Strona": "",
        "Strona %0": "",
        "Strony formularza": "",
        "Studio": "",
        "Stwierdzenie": "",
        "Styl": "",
        "Sukces": "",
        "Suma": "",
        "Suma wartości (Sum)": "",
        "Sumowanie": "",
        "Switch": "",
        "Sygnatura dokumentu": "",
        "Symbol": "",
        "Symbol endpointu": "",
        "Symbol jest wymagany": "",
        "Symbol jest zajęty": "",
        "Symbol modułu": "",
        "Symbol może składać się tylko z małych liter, cyfr oraz znaku - ": "",
        "Symbol musi mieć co najmniej 3 znaki": "",
        "Symbol musi mieć co najmniej 4 znaki": "",
        "Symbol nie może być dłuższy niż 10 znaków": "",
        "Symbol nie może być dłuższy niż 20 znaków": "",
        "Symbol uprawnienia": "",
        "Symbol w adresie URL": "",
        "Symbol: A–Z": "",
        "Symbol: Z–A": "",
        "Synchronizuj": "",
        "System": "",
        "Szablon email": "",
        "Szablon modułu": "",
        "Szablon wiadomości email": "",
        "Szablon: A–Z": "",
        "Szablon: Z–A": "",
        "Szablony definiowane są w ": "",
        "Szczegóły": "",
        "Szczegóły błędu": "",
        "Szczegóły endpointu": "",
        "Szerokość": "",
        "Szerokość geograficzna": "",
        "Szkic": "",
        "Szukaj dokumentu...": "",
        "Szukaj elementu scenariusza": "",
        "Szukaj elementu…": "",
        "Szukaj kategorii…": "",
        "Szukaj kontrolki": "",
        "Szukaj kontrolki…": "",
        "Ta sekcja nie ma pola tekstowego — lista pokazuje najnowsze dokumenty.": "",
        "Tabela": "",
        "Tak": "",
        "Tak/Nie": "",
        "Tekst": "",
        "Tekst lokalizowany": "",
        "Tekst szybki": "",
        "Tekst zaawansowany": "",
        "Tekst zastępczy": "",
        "Telefon": "",
        "Ten dokument edytują również:": "",
        "Teraz": "",
        "Test": "",
        "Testuj": "",
        "Testuj zapytanie": "",
        "Timeout (sekundy)": "",
        "To stały identyfikator systemowy kontrolki. Łączy ją z danymi i ustawieniami formularza, dlatego nie można go zmienić.": "",
        "To techniczny identyfikator pola używany w danych i wyrażeniach formularza. Zmiana nazwy może wymagać aktualizacji odwołań i integracji.": "",
        "Token": "",
        "Transformacja": "",
        "Transformacja kolekcji": "",
        "Treść": "",
        "Treść na przycisku dodawania dokumentu": "",
        "Treść opcji": "",
        "Treści odpowiedzi są wymagane": "",
        "Treści pytań są wymagane": "",
        "True": "",
        "Trwa porównywanie wersji...": "",
        "Tryb edytora formularza": "",
        "Tryb prezentacyjny": "",
        "Tryb zaawansowany": "",
        "Trzy kolumny": "",
        "Tworzenie dokumentów": "",
        "Tworzenie dokumentu": "",
        "Tworzenie encji": "",
        "tydzień": "",
        "Tydzień": "",
        "Tylko do odczytu": "",
        "Tylko JavaScript": "",
        "Typ agregacji": "",
        "Typ autoryzacji": "",
        "Typ kontentu": "",
        "Typ odbiorcy": "",
        "Typ pola": "",
        "Typ wyniku": "",
        "Typ zmiennej": "",
        "TypeScript i instrukcje import nie są obsługiwane.": "",
        "Typy elementów listy": "",
        "Tytuł": "",
        "Tytuł formularza jest wymagany": "",
        "Tytuł formularza nie może być dłuższy niż %0 znaków": "",
        "Tytuł sekcji": "",
        "Udostępnia sekcję w aranżacjach.": "",
        "Układ": "",
        "Ukryj": "",
        "Ukryj filtr w domyślnym widoku.": "",
        "Ukryj kolumnę w domyślnym widoku.": "",
        "Ukryta": "",
        "Ukryty": "",
        "Ukrywa moduł w menu nawigacyjnym.": "",
        "Ukrywa sekcję w menu tego modułu.": "",
        "Ulica": "",
        "Umożliwia korzystanie z modułu w panelu.": "",
        "Unikalna wartość": "",
        "Uprawnienia": "",
        "Uprawnienia do dokumentów": "",
        "Uprawnienia rozróżniają operacje na własnych, wszystkich i wskazanych dokumentach.": "",
        "Url": "",
        "Uruchom proces": "",
        "Uruchomienie harmonogramu": "",
        "Uruchomienie podprocesu": "",
        "Uruchomienie procesu": "",
        "Ustaw szerokości proporcjonalnie": "",
        "Ustawienia": "",
        "Ustawienia formularza": "",
        "Ustawienia kolumny": "",
        "Ustawienia scenariusza": "",
        "Ustawienia sekcji": "",
        "Ustawienia webhooka": "",
        "Ustawienia zostały zapisane.": "",
        "Usuń": "",
        "Usuń dokument": "",
        "Usuń grupę": "",
        "Usuń kolumnę": "",
        "Usuń logi gdy wykonywanie scenariusza": "",
        "Usuń opcję": "",
        "Usuń parametr": "",
        "Usuń pole": "",
        "Usuń pozycję": "",
        "Usuń punkt": "",
        "Usuń pytanie": "",
        "Usuń sekcję": "",
        "Usuń spacje": "",
        "Usuń warunek": "",
        "Usuń wydarzenie": "",
        "Usuń z dokumentami": "",
        "Usunąć grupę uprawnień?": "",
        "Usunąć tę sekcję z modułu?": "",
        "Usunąć uprawnienie?": "",
        "Usunięcie dokumentu": "",
        "Usunięcie formularza\n\nOperacja jest nieodwracalna. Zostaną utracone wszystkie powiązane dokumenty!\nCzy na pewno chcesz usunąć wybrany formularz?": "",
        "Usunięcie wpisu": "",
        "Usunięte": "",
        "Usunięto formularze": "",
        "Usunięto kategorii: {count}.": "",
        "Usunięto scenariusze: {count}.": "",
        "Usuwanie dokumentów": "",
        "Usuwanie duplikatów": "",
        "Usuwanie encji": "",
        "Usuwanie własnych dokumentów": "",
        "Usuwanie wszystkich dokumentów": "",
        "Utwórz formularz": "",
        "Utwórz kopię formularza": "",
        "Utwórz kopię z": "",
        "Utwórz scenariusz": "",
        "Utworzenie wpisu": "",
        "Użycie w aranżacjach": "",
        "Użyj domyślnego zapytania SQL": "",
        "Użytkownik": "",
        "W przyszłości": "",
        "W widgetu zmiennej możliwe jest zdefiniowanie wartości dla jednego z podstawowych typów danych, do wykorzystania w dalszej części procesu.": "",
        "w wyznaczonym zakresie": "",
        "W zapytaniu EQL można używać zmiennych, np.": "",
        "W zapytaniu można używać nazw zmiennych z parametrów wejściowych skryptu, np.:": "",
        "Walidacja": "",
        "Walidacja danych": "",
        "Walidacja po stronie API": "",
        "Walidacja typów MIME": "",
        "Walidacja typu": "",
        "Wariant powiadomienia": "",
        "Wartość": "",
        "Wartość domyślna": "",
        "Wartość jest zbyt długa.": "",
        "Wartość lub wyrażenie": "",
        "Wartość lub wyrażenie C#": "",
        "Wartość opcji": "",
        "Wartość parametru musi pasować do jego użycia w zapytaniu. Może to być": "",
        "Wartość pola": "",
        "Wartośc pola jest wymagana": "",
        "Wartość warunku jest wymagana": "",
        "Wartość zmiennej": "",
        "Wartości zmiennych pochodzą z parametrów GET. Zmiennej": "",
        "Warunek": "",
        "Warunek i mapowanie": "",
        "Warunek jest zdefiniowany przy użyciu wyrażenia lambda w C#. Przykład:": "",
        "Warunek łączenia uprawnień": "",
        "Warunek nie zostanie spełniony": "",
        "Warunek oraz mapowanie używają składni Dynamic LINQ. Przy mapowaniu możesz nadać polu nową nazwę przez as, np. Category.Name as CategoryName.": "",
        "Warunek tylko do odczytu": "",
        "Warunek widoczności": "",
        "Warunek wymagania": "",
        "Warunek zostanie spełniony": "",
        "Warunki": "",
        "Warunki logiczne": "",
        "Warunkowo": "",
        "Ważność": "",
        "Wbudowany skrypt C#": "",
        "Wczytaj opublikowaną definicję formularza.": "",
        "Wczytywanie definicji formularza": "",
        "Wczytywanie formularza…": "",
        "Wczytywanie komponentów": "",
        "Wczytywanie konfiguracji endpointu": "",
        "Wczytywanie kontrolek formularza…": "",
        "Wczytywanie modelu danych": "",
        "Wczytywanie modułów": "",
        "Wczytywanie modułu": "",
        "Wczytywanie modułu…": "",
        "Wczytywanie operacji": "",
        "Wczytywanie operacji formularza": "",
        "Wczytywanie podglądu szablonu…": "",
        "Wczytywanie pól formularza": "",
        "Wczytywanie powtórzeń": "",
        "Wczytywanie procesu": "",
        "Wczytywanie scenariusza": "",
        "Wczytywanie wersji...": "",
        "Wczytywanie właściwości i podglądu szablonu…": "",
        "Webhook": "",
        "Webhook zapisano, ale nie udało się go zaakceptować.": "",
        "Webhook został dodany.": "",
        "Webhook został usunięty.": "",
        "Webhook został zaktualizowany.": "",
        "Webhooki": "",
        "Wersja bazowa": "",
        "Wersja formularza": "",
        "Wersja porównywana": "",
        "Wersja zaakceptowana": "",
        "Wersje": "",
        "Wersje i uprawnienia": "",
        "Wersjonowany": "",
        "Wewnętrznie": "",
        "Widget służy do budowania obiektu z wybranych wartości.": "",
        "Widget służy do parsowania szablonów w języku Liquid.": "",
        "Widget służy do renderowania MJML na HTML": "",
        "Widget umożliwia uruchomienie dowolnego wbudowanego skryptu C#.": "",
        "Widget wybiera model z globalnej konfiguracji AI zgodnie z typem wyniku. Nie wybiera konkretnego modelu.": "",
        "Widget wyzwala scenariusz po wykonaniu akcji wybranej w polu": "",
        "Widget zwraca prawdę, gdy wejściowa wartość ma przynajmniej jeden zaznaczony typ. Dla listy możesz dodatkowo ograniczyć typ każdego jej elementu.": "",
        "Widget zwracana wybrany szablon wiadomości email.": "",
        "Widoczność": "",
        "Widoczność sekcji w menu modułu": "",
        "Widoczność w menu": "",
        "Widok diagramu": "",
        "Widok kalendarza": "",
        "Więcej...": "",
        "Większe lub równe": "",
        "Większe niż": "",
        "Wielkość kroku": "",
        "Wielokrotny": "",
        "Wiersz": "",
        "Wiersz %0": "",
        "Wiersze do importu:": "",
        "Wklej komponent": "",
        "Włącz": "",
        "Włącz konfigurację zaawansowaną, aby zdefiniować własne zapytanie EQL i przetestować jego wynik.": "",
        "Włącz walidację po stronie API": "",
        "Włącza przyjmowanie żądań przez webhook.": "",
        "Włączone": "",
        "Właściwości": "",
        "Właściwości komponentu": "",
        "Właściwości szablonu": "",
        "Właściwości wpisu": "",
        "Województwo": "",
        "Wpis został dodany.": "",
        "Wpis został usunięty": "",
        "Wpis został zaakceptowany.": "",
        "Wpis został zaktualizowany.": "",
        "Wpisz ciało funkcji walidującej dane w JavaScript.": "",
        "Wpisz co najmniej 4 znaki.": "",
        "Wróć do diagramu": "",
        "Wskaż formularz, którego pola mają pojawić się w edytorze konta. Zmiana dotyczy wszystkich kont - wcześniej wprowadzone wartości pozostają zapisane.": "",
        "Wskaż moduł, sekcję i metodę, aby zobaczyć adres oraz konfigurację.": "",
        "Wskaż pole liczbowe, na którym ma zostać obliczona wybrana operacja.": "",
        "Wskazuje, jak długo odpowiedź pozostaje aktualna w pamięci serwera Redis.": "",
        "Wstaw kontrolkę": "",
        "Wstaw stronę": "",
        "Wstaw z dołu": "",
        "Wstaw z góry": "",
        "Wstaw z lewej strony": "",
        "Wstaw z prawej strony": "",
        "Wstecz": "",
        "Wszystkie": "",
        "Wybierz": "",
        "Wybierz co najmniej jeden typ wartości.": "",
        "Wybierz dokumenty": "",
        "Wybierz dostępny szablon modułu.": "",
        "Wybierz endpoint": "",
        "Wybierz formularz": "",
        "Wybierz formularz, aby zobaczyć jego pola.": "",
        "Wybierz kategorię": "",
        "Wybierz kontrolkę lub miejsce jej wstawienia.": "",
        "Wybierz model docelowy, gdy zmapowany wynik ma być traktowany jako jego rekord.": "",
        "Wybierz model, dodaj warunek tylko dla potrzebnych rekordów i dobierz operację do oczekiwanego wyniku.": "",
        "Wybierz moduł": "",
        "Wybierz moduł z menu po lewej stronie, aby edytować jego zawartość.": "",
        "Wybierz moduł, aby dodać sekcję – lub zostaw puste, aby utworzyć nowy moduł": "",
        "wybierz moduł...": "",
        "Wybierz operację, aby zobaczyć wynik i szczegóły.": "",
        "Wybierz plik CSV": "",
        "Wybierz sekcję": "",
        "wybierz sekcję...": "",
        "Wybierz typ wartości.": "",
        "Wybierz typ wyniku.": "",
        "wybierz...": "",
        "Wybierz…": "",
        "Wybór": "",
        "Wybór formularza": "",
        "Wybór języka": "",
        "Wybór operacji jest wymagany.": "",
        "Wybór wpływa na kolor szablonu.": "",
        "Wybór wpływa tylko na treść stopki.": "",
        "Wybór+": "",
        "Wybrana data jest mniejsza niż dozwolona %0.": "",
        "Wybrana data jest większa niż dozwolona %0.": "",
        "Wybrana godzina jest późniejsza niż dozwolona %0.": "",
        "Wybrana godzina jest wcześniejsza niż dozwolona %0.": "",
        "Wybrana liczba jest mniejsza niż dozwolona %0.": "",
        "Wybrana liczba jest większa niż dozwolona %0.": "",
        "Wybrana wersja": "",
        "Wybrane": "",
        "Wybrane dokumenty": "",
        "Wybrane: %0": "",
        "Wybranie przynajmniej jednego pola do aktualizacji jest wymagane.": "",
        "Wybranie przynajmniej jednego warunku jest wymagane.": "",
        "Wybrany formularz nie zawiera pól.": "",
        "Wybrany użytkownik": "",
        "Wyczyść": "",
        "Wyczyść wartość": "",
        "Wyczyść wybór": "",
        "Wyczyść wyszukiwanie": "",
        "Wyczyścić uprawnienia sekcji?": "",
        "Wydarzenie zostało zduplikowane.": "",
        "Wygląd formularza z wybranymi ustawieniami.": "",
        "Wygląd modułu i formularza po konfiguracji.": "",
        "Wykonuje się": "",
        "Wykryto kolumny:": "",
        "Wyłączone": "",
        "Wyłuskaj dane do wybranej właściwości poprzez wyrażenie w formacie języka C#. Albo zostaw pole puste, wtedy zostanie zwrócony cały wynik.": "",
        "Wymaga autoryzacji": "",
        "Wymagana konfiguracja": "",
        "Wymagane": "",
        "Wymagane jest wybranie formularza": "",
        "Wymagane jest wybranie kategorii": "",
        "Wymagane jest wybranie komponentu": "",
        "Wymagane jest wybranie modułu": "",
        "Wymagane jest wybranie sekcji": "",
        "Wymagane jest wybranie źródła": "",
        "Wymagane jest wybranie źródła danych": "",
        "Wymagane znaki": "",
        "Wymień wpis": "",
        "Wynik etapu (JSON)": "",
        "Wynik etapu jest wymagany": "",
        "Wynik operacji": "",
        "Wynik testu": "",
        "Wynik transformacji": "",
        "Wynik walidacji": "",
        "Wyrażenia warunkowe": "",
        "Wyrażenie EQL": "",
        "Wyrażenie jest prawidłowe. Udało się pobrać wartość z wyniku.": "",
        "Wyrażenie nie jest prawidłowe. Nie udało się pobrać wartości z wyniku.": "",
        "Wyrażenie regularne": "",
        "Wyrażenie w postaci \"/pattern/flag\" nie jest obsługiwane, użyj same wartości pattern": "",
        "Wysłanie emaila": "",
        "Wysłanie powiadomień": "",
        "Wyślij": "",
        "Wyślij powiadomienie gdy wykonywanie scenariusza": "",
        "Wysoka": "",
        "Wystąpił błąd podczas otwierania modułu. Możesz spróbować ponownie lub wrócić do listy modułów.": "",
        "Wystąpił błąd podczas próby importu definicji modułu.": "",
        "Wystąpił nieokreślony problem.": "",
        "Wyświetlanie dokumentów": "",
        "Wyszukaj encję…": "",
        "Wyszukiwany ciąg znaków": "",
        "Wytnij": "",
        "Wywołanie powiadomienia": "",
        "Wywołanie webhooka": "",
        "Wywołanie zdarzenia": "",
        "Wyzwalacze": "",
        "Wzorzec": "",
        "Z uprawnieniami do modułu": "",
        "Zaakceptowany": "",
        "Zaawansowane": "",
        "Zaawansowane uprawnienia": "",
        "Zaawansowany edytor tekstu": "",
        "Zablokuj edycję diagramu": "",
        "Zachowaj oryginalny format obrazów": "",
        "zacznij pisać aby wyszukać szablon...": "",
        "zacznij pisać aby wyszukać użytkownika...": "",
        "Zacznij pisać Form lub Entry aby uruchomić podpowiadanie.": "",
        "Zaczyna sie od": "",
        "Zagrożenie": "",
        "Zaimportowano definicję modułu.": "",
        "Zakładki": "",
        "Zakończ edycje": "",
        "Zakończony": "",
        "zakończy się porażką": "",
        "zakończy się sukcesem": "",
        "Zakres": "",
        "Zakres czasu": "",
        "Zakres funkcjonalności": "",
        "Zakres uprawnienia": "",
        "Zaktualizuj formularz": "",
        "Zaktualizuj najnowszą wersję dokumentu": "",
        "Załączniki": "",
        "Zależna od kontrolki": "",
        "Zamień wersje": "",
        "Zamknij": "",
        "Zaokrąglenie": "",
        "Zapisz": "",
        "Zapisz i wróć": "",
        "Zapisz i zamknij": "",
        "Zapisz jako": "",
        "Zapisz kategorię": "",
        "Zapisz pozycje": "",
        "Zapisz zmiany": "",
        "Zapytania i mapowanie kolumn": "",
        "Zapytanie": "",
        "Zapytanie do bazy danych": "",
        "Zapytanie HTTP": "",
        "Zapytanie SQL do pobrania po ID": "",
        "Zapytanie SQL do wyszukiwania": "",
        "Zasięg": "",
        "Zawiera": "",
        "Zawiera nagłówki": "",
        "Zawiera parametry query": "",
        "Zawiera treść": "",
        "Zawsze": "",
        "Zdecyduj czy scenariusz ma obsługiwać wczystkie czy tylko wybrane powiadomienia.": "",
        "Zdecyduj czy scenariusz ma obsługiwać wszystkie czy tylko wybrane kanały.": "",
        "Zdefiniuj wygląd komponentu oraz opcjonalne reguły sprawdzania danych po stronie API.": "",
        "Zdjęcia": "",
        "Zdjęcie": "",
        "Zestaw uprawnień": "",
        "Zgoda": "",
        "Zliczanie": "",
        "Zmiana statusu jest teraz niedostępna.": "",
        "Zmiany": "",
        "Zmiany zostały zapisane.": "",
        "Zmienione": "",
        "Zmienna": "",
        "Zmienna musi się zaczynać od małej litery i może zawierać tylko znaki alfanumeryczne": "",
        "Zmienne w zapytaniu EQL": "",
        "Zmniejsz": "",
        "Znaczenie operacji": "",
        "Znaki specialne": "",
        "Zoom": "",
        "Zostaną zaktualizowane definicje wszystkich dokumentów.": "",
        "Źródła danych": "",
        "Źródło danych": "",
        "Żródło danych": "",
        "Źródło danych zostało dodane.": "",
        "Źródło danych zostało zaktualizowane.": "",
        "Źródło zostało usunięte.": "",
        "Zwrócony": ""
    }
};
